module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages"
  }, [_c('com-title', {
    attrs: {
      "title": "合作伙伴寄语"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "columns"
  }, _vm._l((_vm.messages), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-tablet"
    }, [_c('a', {
      staticClass: "wrap",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "content-wrapper"
    }, [_c('div', {
      staticClass: "logo"
    }, [_c('img', {
      attrs: {
        "src": item.logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "word"
    }, [_c('span', {
      staticClass: "word-content"
    }, [_vm._v(_vm._s(item.word))]), _vm._v(" "), _c('div', {
      staticClass: "word-author"
    }, [_c('span', [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.company))])])])]), _vm._v(" "), _c('div', {
      staticClass: "hover"
    }, [_c('span', {
      staticClass: "word-content"
    }, [_vm._v(_vm._s(item.word))])])])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077a1623","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/partner/com-message.vue
// module id = 434
// module chunks = 1